function triggerLoadBuildReducer(currentState = false, action){
    switch (action.type) {
        case 'TRIGGER_LOADBUILD':
            return action.payload;
        default:
            break;
    }
    return currentState;
}

export default triggerLoadBuildReducer;